// // import React, { useState, useEffect } from "react";
// // import "./AddService.css";

// // const MAIN_SERVICES = [
// //   "Electrician",
// //   "Plumber",
// //   "Cleaning",
// //   "Wood Work",
// //   "Car Driver",
// //   "Bike Repair",
// //   "Car Repair",
// //   "Wedding Beautician",
// //   "Catering",
// //   "Painting",
// //   "AC Repair",
// //   "Home Stay",
// //   "Medical",
// //   "Electriction",
// // ];

// // export default function AddServiceForm() {
// //   const [formData, setFormData] = useState({
// //     main_service: "",
// //     sub_service_title: "",
// //     sub_service_description: "",
// //     price: "",
// //     discount_price: "",
// //     discount_percent: "",
// //   });

// //   const [imageFile, setImageFile] = useState(null);
// //   const [loading, setLoading] = useState(false);

// //   // Auto-update discount price when price or discount percent changes
// //   useEffect(() => {
// //     const price = parseFloat(formData.price) || 0;
// //     const percent = parseFloat(formData.discount_percent) || 0;
// //     if (price && percent >= 0) {
// //       const discounted = price - (price * percent) / 100;
// //       setFormData(prev => ({ ...prev, discount_price: discounted.toFixed(2) }));
// //     } else {
// //       setFormData(prev => ({ ...prev, discount_price: "" }));
// //     }
// //   }, [formData.price, formData.discount_percent]);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData(prev => ({ ...prev, [name]: value }));
// //   };

// //   const handleFileChange = (e) => {
// //     setImageFile(e.target.files[0]);
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!imageFile) {
// //       alert("Please select an image file.");
// //       return;
// //     }

// //     setLoading(true);
// //     const data = new FormData();
// //     Object.entries(formData).forEach(([key, value]) => {
// //       if (value) data.append(key, value);
// //     });
// //     data.append("image_file", imageFile);

// //     try {
// //       const response = await fetch(
// //         "https://www.actrofiteinfotech.com/rootservices/dashboard/insert_service.php",
// //         { method: "POST", body: data }
// //       );
// //       const result = await response.json();
// //       alert(result.message);
// //       if (result.status === "success") {
// //         setFormData({
// //           main_service: "",
// //           sub_service_title: "",
// //           sub_service_description: "",
// //           price: "",
// //           discount_price: "",
// //           discount_percent: "",
// //         });
// //         setImageFile(null);
// //         e.target.reset();
// //       }
// //     } catch (error) {
// //       alert("Error submitting form: " + error.message);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const hasValue = (field) =>
// //     formData[field] && formData[field].toString().trim() !== "";

// //   return (
// //     <form className="add-service-form" onSubmit={handleSubmit} noValidate>
// //       {/* Main Service */}
// //       <div className="form-group">
// //         <select
// //           name="main_service"
// //           value={formData.main_service}
// //           onChange={handleChange}
// //           required
// //           className={`form-select ${hasValue("main_service") ? "has-value" : ""}`}
// //         >
// //           <option value="" disabled hidden>
// //             Select Main Service
// //           </option>
// //           {MAIN_SERVICES.map(service => (
// //             <option key={service} value={service}>{service}</option>
// //           ))}
// //         </select>
// //         <label className={`form-label ${hasValue("main_service") ? "label-floating" : ""}`}>
// //           Main Service
// //         </label>
// //       </div>

// //       {/* Sub Service Title */}
// //       <div className="form-group">
// //         <input
// //           type="text"
// //           name="sub_service_title"
// //           value={formData.sub_service_title}
// //           onChange={handleChange}
// //           required
// //           className={`form-input ${hasValue("sub_service_title") ? "has-value" : ""}`}
// //           placeholder=" "
// //         />
// //         <label className={`form-label ${hasValue("sub_service_title") ? "label-floating" : ""}`}>
// //           Sub Service Title
// //         </label>
// //       </div>

// //       {/* Sub Service Description */}
// //       <div className="form-group">
// //         <textarea
// //           name="sub_service_description"
// //           value={formData.sub_service_description}
// //           onChange={handleChange}
// //           required
// //           rows={4}
// //           className={`form-textarea ${hasValue("sub_service_description") ? "has-value" : ""}`}
// //           placeholder=" "
// //         />
// //         <label className={`form-label ${hasValue("sub_service_description") ? "label-floating" : ""}`}>
// //           Sub Service Description
// //         </label>
// //       </div>

// //       {/* Price */}
// //       <div className="form-group">
// //         <input
// //           type="number"
// //           step="0.01"
// //           name="price"
// //           value={formData.price}
// //           onChange={handleChange}
// //           required
// //           className={`form-input ${hasValue("price") ? "has-value" : ""}`}
// //           placeholder=" "
// //         />
// //         <label className={`form-label ${hasValue("price") ? "label-floating" : ""}`}>
// //           Price
// //         </label>
// //       </div>

// //       {/* Discount Percent */}
// //       <div className="form-group">
// //         <input
// //           type="number"
// //           step="0.01"
// //           name="discount_percent"
// //           value={formData.discount_percent}
// //           onChange={handleChange}
// //           className={`form-input ${hasValue("discount_percent") ? "has-value" : ""}`}
// //           placeholder=" "
// //         />
// //         <label className={`form-label ${hasValue("discount_percent") ? "label-floating" : ""}`}>
// //           Discount Percent
// //         </label>
// //       </div>

// //       {/* Discount Price (readonly) */}
// //       <div className="form-group">
// //         <input
// //           type="number"
// //           step="0.01"
// //           name="discount_price"
// //           value={formData.discount_price}
// //           readOnly
// //           className={`form-input ${hasValue("discount_price") ? "has-value" : ""}`}
// //           placeholder=" "
// //         />
// //         <label className={`form-label ${hasValue("discount_price") ? "label-floating" : ""}`}>
// //           Discount Price
// //         </label>
// //       </div>

// //       {/* Image Upload */}
// //       <div className="form-group">
// //         <input
// //           type="file"
// //           accept=".jpg,.jpeg,.png,.gif,.avif,.webp,.svg,.bmp"
// //           onChange={handleFileChange}
// //           required
// //           className="form-file-input"
// //         />
// //       </div>

// //       {/* Submit Button */}
// //       <button type="submit" className="form-submit-btn" disabled={loading}>
// //         {loading ? "Submitting..." : "Submit"}
// //       </button>
// //     </form>
// //   );
// // }


// import React, { useState, useEffect } from "react";
// import "./AddServiceModern.css";

// const MAIN_SERVICES = [
//   "Electrician","Plumber","Cleaning","Wood Work","Car Driver",
//   "Bike Repair","Car Repair","Wedding Beautician","Catering",
//   "Painting","AC Repair","Home Stay","Medical","Electriction"
// ];

// export default function AddServiceForm() {
//   const [formData, setFormData] = useState({
//     main_service: "",
//     sub_service_title: "",
//     sub_service_description: "",
//     price: "",
//     discount_price: "",
//     discount_percent: "",
//   });

//   const [imageFile, setImageFile] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const price = parseFloat(formData.price) || 0;
//     const percent = parseFloat(formData.discount_percent) || 0;
//     if (price && percent >= 0) {
//       const discounted = price - (price * percent) / 100;
//       setFormData(prev => ({ ...prev, discount_price: discounted.toFixed(2) }));
//     } else {
//       setFormData(prev => ({ ...prev, discount_price: "" }));
//     }
//   }, [formData.price, formData.discount_percent]);

//   const handleChange = e => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = e => {
//     const file = e.target.files[0];
//     setImageFile(file);
//     if (file) setImagePreview(URL.createObjectURL(file));
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     if (!imageFile) return alert("Please select an image file.");
//     setLoading(true);

//     const data = new FormData();
//     Object.entries(formData).forEach(([k,v]) => { if(v) data.append(k,v); });
//     data.append("image_file", imageFile);

//     try {
//       const res = await fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/insert_service.php", { method:"POST", body:data });
//       const result = await res.json();
//       alert(result.message);
//       if(result.status==="success"){
//         setFormData({main_service:"",sub_service_title:"",sub_service_description:"",price:"",discount_price:"",discount_percent:""});
//         setImageFile(null);
//         setImagePreview(null);
//         e.target.reset();
//       }
//     } catch(err) {
//       alert("Error submitting form: "+err.message);
//     } finally { setLoading(false); }
//   };

//   const hasValue = field => formData[field] && formData[field].toString().trim() !== "";

//   return (
//     <form className="modern-add-service-form" onSubmit={handleSubmit} noValidate>
//       <h2>Add New Service</h2>

//       <div className="form-group">
//         <select name="main_service" value={formData.main_service} onChange={handleChange} required className={hasValue("main_service") ? "has-value" : ""}>
//           <option value="" disabled hidden>Select Main Service</option>
//           {MAIN_SERVICES.map(s => <option key={s} value={s}>{s}</option>)}
//         </select>
//         <label>Main Service</label>
//       </div>

//       <div className="form-group">
//         <input type="text" name="sub_service_title" value={formData.sub_service_title} onChange={handleChange} required className={hasValue("sub_service_title") ? "has-value" : ""}/>
//         <label>Sub Service Title</label>
//       </div>

//       <div className="form-group">
//         <textarea name="sub_service_description" value={formData.sub_service_description} onChange={handleChange} required rows={4} className={hasValue("sub_service_description") ? "has-value" : ""}/>
//         <label>Sub Service Description</label>
//       </div>

//       <div className="form-group">
//         <input type="number" step="0.01" name="price" value={formData.price} onChange={handleChange} required className={hasValue("price") ? "has-value" : ""}/>
//         <label>Price</label>
//       </div>

//       <div className="form-group">
//         <input type="number" step="0.01" name="discount_percent" value={formData.discount_percent} onChange={handleChange} className={hasValue("discount_percent") ? "has-value" : ""}/>
//         <label>Discount Percent</label>
//       </div>

//       <div className="form-group">
//         <input type="number" step="0.01" name="discount_price" value={formData.discount_price} readOnly className={hasValue("discount_price") ? "has-value" : ""}/>
//         <label>Discount Price</label>
//       </div>

//       <div className="form-group file-group">
//         <input type="file" accept="image/*" onChange={handleFileChange} required/>
//         {imagePreview && <img src={imagePreview} alt="Preview" className="image-preview"/>}
//       </div>

//       <button type="submit" className="submit-btn" disabled={loading}>{loading ? "Submitting..." : "Submit"}</button>
//     </form>
//   );
// }


import React, { useState, useEffect } from "react";
import "./AddService.css";

const MAIN_SERVICES = [
  "Electrician",
  "Plumber",
  "Cleaning",
  "Wood Work",
  "Car Driver",
  "Bike Repair",
  "Car Repair",
  "Wedding Beautician",
  "Catering",
  "Painting",
  "AC Repair",
  "Home Stay",
  "Medical",
  "Electriction",
  "construction & home repair",
];

export default function AddServiceForm() {
  const [formData, setFormData] = useState({
    main_service: "",
    sub_service_title: "",
    sub_service_description: "",
    price: "",
    discount_price: "",
    discount_percent: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // Auto-update discount price instantly
  const updateDiscountPrice = (price, percent) => {
    const p = parseFloat(price) || 0;
    const d = parseFloat(percent) || 0;
    return ((p * (100 - d)) / 100).toFixed(2);
  };

  useEffect(() => {
    const newDiscount = updateDiscountPrice(formData.price, formData.discount_percent);
    setFormData(prev => ({ ...prev, discount_price: newDiscount }));
  }, [formData.price, formData.discount_percent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imageFile) {
      alert("Please select an image file.");
      return;
    }

    setLoading(true);
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value) data.append(key, value);
    });
    data.append("image_file", imageFile);

    try {
      const response = await fetch(
        "https://www.actrofiteinfotech.com/rootservices/dashboard/insert_service.php",
        { method: "POST", body: data }
      );
      const result = await response.json();
      alert(result.message);
      if (result.status === "success") {
        setFormData({
          main_service: "",
          sub_service_title: "",
          sub_service_description: "",
          price: "",
          discount_price: "",
          discount_percent: "",
        });
        setImageFile(null);
        e.target.reset();
      }
    } catch (error) {
      alert("Error submitting form: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const hasValue = (field) =>
    formData[field] && formData[field].toString().trim() !== "";

  return (
    <form className="add-service-form" onSubmit={handleSubmit} noValidate>
      {/* Main Service */}
      <div className="form-group">
        <select
          name="main_service"
          value={formData.main_service}
          onChange={handleChange}
          required
          className={`form-select ${hasValue("main_service") ? "has-value" : ""}`}
        >
          <option value="" disabled hidden>
            Select Main Service
          </option>
          {MAIN_SERVICES.map(service => (
            <option key={service} value={service}>{service}</option>
          ))}
        </select>
        <label className={`form-label ${hasValue("main_service") ? "label-floating" : ""}`}>
          Main Service
        </label>
      </div>

      {/* Sub Service Title */}
      <div className="form-group">
        <input
          type="text"
          name="sub_service_title"
          value={formData.sub_service_title}
          onChange={handleChange}
          required
          className={`form-input ${hasValue("sub_service_title") ? "has-value" : ""}`}
          placeholder=" "
        />
        <label className={`form-label ${hasValue("sub_service_title") ? "label-floating" : ""}`}>
          Sub Service Title
        </label>
      </div>

      {/* Sub Service Description */}
      <div className="form-group">
        <textarea
          name="sub_service_description"
          value={formData.sub_service_description}
          onChange={handleChange}
          required
          rows={4}
          className={`form-textarea ${hasValue("sub_service_description") ? "has-value" : ""}`}
          placeholder=" "
        />
        <label className={`form-label ${hasValue("sub_service_description") ? "label-floating" : ""}`}>
          Sub Service Description
        </label>
      </div>

      {/* Price */}
      <div className="form-group">
        <input
          type="number"
          step="0.01"
          name="price"
          value={formData.price}
          onChange={handleChange}
          required
          className={`form-input ${hasValue("price") ? "has-value" : ""}`}
          placeholder=" "
        />
        <label className={`form-label ${hasValue("price") ? "label-floating" : ""}`}>
          Price
        </label>
      </div>

      {/* Discount Percent */}
      <div className="form-group">
        <input
          type="number"
          step="0.01"
          name="discount_percent"
          value={formData.discount_percent}
          onChange={handleChange}
          className={`form-input ${hasValue("discount_percent") ? "has-value" : ""}`}
          placeholder=" "
        />
        <label className={`form-label ${hasValue("discount_percent") ? "label-floating" : ""}`}>
          Discount Percent
        </label>
      </div>

      {/* Discount Price (readonly) */}
      <div className="form-group">
        <input
          type="number"
          step="0.01"
          name="discount_price"
          value={formData.discount_price}
          readOnly
          className={`form-input ${hasValue("discount_price") ? "has-value" : ""}`}
          placeholder=" "
        />
        <label className={`form-label ${hasValue("discount_price") ? "label-floating" : ""}`}>
          Discount Price
        </label>
      </div>

      {/* Image Upload */}
      <div className="form-group">
        <input
          type="file"
          accept=".jpg,.jpeg,.png,.gif,.avif,.webp,.svg,.bmp"
          onChange={handleFileChange}
          required
          className="form-file-input"
        />
      </div>

      {/* Submit Button */}
      <button type="submit" className="form-submit-btn" disabled={loading}>
        {loading ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
}
